import React, { Component } from 'react';

import analytics from 'client/analytics';
import { ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK } from 'client/analytics/eventList';

import { SCREEN_ID_FAQ_MOVE_IN_DATE } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';

@withTransitionHook
@withScreenId(SCREEN_ID_FAQ_MOVE_IN_DATE)
@withScrollToTop
class FaqMoveInDate extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'FAQ Move-in Date | Sunroom Rentals',
    section: 'FAQ Move-in Date',
    // canonical: '/',
    keywords: 'rent, home, austin, tour, apartment, sunroom faq',
    description: (
      'Common Move-in Date Questions From Renters: '
    ),
  })

  _onTextExpertButtonClick = () => {
    analytics.track(ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK);
  }

  render() {
    return (
      <div className='page-faq'>
        <Navbar
          leftButton={(
            <SrLink
              className='link back'
              restoreScrollPosition
              redirectToLastLocation
              to='/feed'
            />
          )}
        />

        <div className='faq'>
          <span className='headline'>How does the move-in date work for rentals?</span>

          <div className='questionsContainer'>
            <span className='question'>How important is my move-in date?</span>
            <span className='answer'>
              <span className='bold color-green'>Your move-in date is extremely important. </span>
              {
                'Landlords commonly select renters who want to move within 15 days ' +
                'after the home became available! If the home is already available, ' +
                'that means they want you moving within 2 weeks from the day you decide ' +
                'you like the place. You can understand this better if you think of ' +
                'it from the landlord\'s perspective: They lose more money if their ' +
                'home stays vacant longer.'
              }
            </span>
            <span className='question'>How do I know a rental property matches my move-in date?</span>
            <span className='answer'>
              If you're
              <span className='bold color-green'>
                {
                  ' moving within 2 weeks after a property becomes available'
                }
              </span>
              {
                ', that\'s a match! If a home\'s available date is before today, and you ' +
                'are moving within 2 weeks from today, that\'s also a match! Any other scenario ' +
                'means the home does not match your move-in date.'
              }
            </span>
            <span className='question'>How do I easily find the homes that match my move-in date?</span>
            <span className='answer'>
              {
                'On Sunroom, we made it easy to look for homes that are within 2 weeks ' +
                'from the date you plan on moving. Go to your search filters and '
              }
              <span className='bold color-green'>
                {
                  'turn on the move-in date switch '
                }
              </span>
              <span>
                {
                  'to just see homes near your move-in date. With that move-in date switch turned on, ' +
                  'you\'ll only see homes you have a stronger chance of getting approved for.'
                }
              </span>
            </span>
            <span className='question'>When should I start touring & applying?</span>
            <span className='answer'>
              Tour 3-6 weeks & apply 2-3 weeks before you’re ready to start paying rent.
            </span>
            <span className='question'>Will Sunroom let me tour homes that don't match my move-in date?</span>
            <span className='answer'>
              {
                'Yes, we\'re happy to help you tour homes! But you should know there\'s ' +
                'a low chance landlords will approve you to rent homes that don\'t match your move-in date.'
              }
            </span>
          </div>
        </div>

        <div className='mainContainer'>
          <span className='headline'>Text us questions</span>
          <div className='teamPhoto' />
          <span className='bodyText'>
            If you have questions about a home or apartment, send us a text.
            We can call the landlord on your behalf, schedule tours, process your
            application and also provide general rental hunting tips.
            <br />
            <br />
            Feel free to link me rentals you find on other sites. We'll make sure
            you get to tour the home whenever you want!
          </span>
          <a href='sms:+15127143550' onClick={this._onTextExpertButtonClick} className='button blue'>
            <span className='prompt'>text an expert</span>
          </a>
        </div>
      </div>
    );
  }
}

FaqMoveInDate.displayName = 'FaqMoveInDate';

export default FaqMoveInDate;
